// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/heroback.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/images/documentation-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-content {
  width: calc(100% - 250px);
  padding: 20px;
  margin-left: 250px;
}
.logo img {
  width: 150px;
}
.sidebar {
  position: fixed;
  top: 0;
  left: -250px;
  width: 250px;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  transition: left 0.3s ease;
  overflow-x: hidden;
  padding: 20px;
}

.sidebar.open {
  left: 0;
}

.toggle-button {
  display: none;
  position: absolute;
  z-index: 99999;
  top: 0px;
  transform: translate(125%, 0);

  padding: 14px 0px;
  border-radius: 6px;
  background: rgba(1, 188, 141, 1);
  border: 1px solid rgba(201, 227, 235, 0.2);
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  color: rgba(223, 224, 231, 1);
  background: transparent;
  border: none;
}

.sidebar-content {
  color: white;
}

.sidebar-content ul {
  list-style-type: none;
  padding: 0;
  margin-top: 20px;
}

.sidebar-content ul li a {
  color: white;
  text-decoration: none;
  font-family: "Roboto", sans-serif;
  font-size: 16.1px;
  font-weight: 500;
  line-height: 12.11px;
  display: block;
  padding: 14px 10px;
  border-radius: 5px;
  margin-bottom: 14px;
  background: #ffffff1a;
}
.sidebar-content ul li.active a {
  /* background: linear-gradient(90deg, #5A576B 0%, #484258 60%, #413951 100%); */
  /* background: linear-gradient(90deg, #408171 0%, #3f878f 60%, #4cbdb6 100%); */
  background-color: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(217, 217, 217, 0.2);
}
.sidebar-content ul li a:hover {
  /* background: linear-gradient(90deg, #5A576B 0%, #484258 60%, #413951 100%); */
  /* background: linear-gradient(90deg, #408171 0%, #3f878f 60%, #4cbdb6 100%); */
  background-color: #36c478;
  cursor: pointer;
}
.sidebar-content ul li a img {
  margin-right: 10px;
}
.dashboardapp {
  background-color: #0a0c1b;
  min-height: 100vh;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
}

.documentation {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 20px;
  color: white;
  position: absolute;
  bottom: 10px;
  width: 220px;
}
.documentation h5 {
  font-family: "Roboto", sans-serif;
  font-size: 12.85px;
  font-weight: 700;
  line-height: 17.99px;
  text-align: left;
}
.documentation p {
  font-family: "Roboto", sans-serif;
  font-size: 11.01px;
  font-weight: 400;
  line-height: 11.01px;
  text-align: left;
}
.documentation a {
  font-family: "Roboto", sans-serif;
  font-size: 11px;
  font-weight: 700;
  line-height: 9.18px;
  text-align: center;
  border-radius: 5px;
  background: rgba(0, 9, 11, 1);
  border: none;
  width: 100%;
  padding: 15px 10px;
  color: white;
  display: block;
  text-decoration: none;
}
section.dashboardhero {
  background: none;
  min-height: auto;
  height: auto;
}
section.dashboardhero .calculator .content {
  border-radius: 9px;
}
section.wallethero .calculator .content {
  background: none;
  padding: 0px;
}
section.wallethero .calculateform .calculate-btn button {
  background: #162859;
  justify-content: center;
}
section.wallethero .calculateform .calculate-btn button:hover {
  border: none;
}
section.wallethero .react-tel-input .form-control {
  width: 100%;
  padding-left: 60px;
}
section.wallethero .react-tel-input .selected-flag {
  width: 48px;
}
section.wallethero .react-tel-input .country-list {
  text-align: left;
  text-align: -webkit-left;
  text-align: -moz-left;
}
section.wallethero .react-tel-input .flag-dropdown {
  background-color: #242424;
  border: 1px solid #000;
}
.wallet-modal .modal-header {
  justify-content: end;
}
.wallet-modal .modal-header svg {
  font-size: 28px;
  color: #fff;
}
.wallet-modal .modal-header svg:hover {
  cursor: pointer;
}
.inner-content-dashboard {
  padding: 25.1px 14px 26px 14px;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.1);
}
header {
  background: #ffffff1a;
  border-radius: 12px;
  padding: 12px 20px;
}
.header-btn {
  border: 1px solid #ffffff;
  background: #ffffff1a;
  gap: 10px;
  border-radius: 6px;
  padding: 6px 12px;
  color: #fff;
  font-weight: 400;
  font-size: 13px;
  line-height: 19.5px;
  letter-spacing: 0.4px;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
}
.header-btn:is(:hover, :active) {
  border: 1px solid #36c478;
  color: #36c478;
}

.header-btn .image {
  width: 25px;
}
.header-btn img {
  width: 100%;
  height: auto;
}
.inner-content-dashboard h2 {
  color: white;
  font-size: 22px;
  font-family: "Roboto", sans-serif;
  font-weight: 800;
  line-height: 30.8px;
  letter-spacing: 0.34px;
}
.inner-balance {
  /* background: linear-gradient(90deg, #5A576B 0%, #484258 60%, #413951 100%); */
  /* background: linear-gradient(90deg, #408171 0%, #3f878f 60%, #4cbdb6 100%); */
  /* background-color: #36C478; */
  border-radius: 10px;
  padding: 15px;
  border: 1px solid;
  background: #ffffff1f;
  backdrop-filter: blur(101.58px);
  border-image-source: linear-gradient(
    272.61deg,
    rgba(226, 226, 226, 0.5) 23.59%,
    rgba(116, 125, 152, 0) 85.98%
  );
}
.inner-content-dashboard p {
  color: white;
  font-size: 16px;
  font-family: "Roboto";
  font-weight: 400;
  line-height: 18px;
}
.inner-balance p {
  color: #e9edf7;
  font-size: 17px;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  line-height: 20px;
}
.inner-balance h1 {
  color: white;
  font-size: 30px;
  font-family: Roboto;
  font-weight: 500;
  line-height: 42px;
  line-break: anywhere;
}
.inner-balance h1 button svg {
  color: #fff;
}
.balance h3 {
  color: white;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 700;
  line-height: 19.6px;
}
.Referral-code .form {
  padding: 6px 7px 6px 22px;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.1);

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Referral-code .form h4 {
  font-family: "Roboto", sans-serif;
  font-size: 16.63px;
  font-weight: 400;
  line-height: 20.12px;
  text-align: center;
  color: rgba(223, 224, 231, 1);
  margin: 0px;
}
.progress-bar {
  background-color: #36c478;
}
.Referral-code .form button, 
.validate-btn {
  padding: 12px 24px;
  border-radius: 6px;
  /* background: linear-gradient(90deg, #5A576B 0%, #484258 60%, #413951 100%); */
  /* background: linear-gradient(90deg, #379092 0%, #0aa7a1 60%, #1ba79d 100%); */
  background: #000000;
  border: 1px solid rgba(201, 227, 235, 0.2);
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  color: rgba(223, 224, 231, 1);
}
.inner-content-dashboard .table-responsive {
  white-space: nowrap;
}
.inner-content-dashboard table th {
  color: white;
  font-size: 16px;
  font-family: "Roboto";
  font-weight: 700;
  text-decoration: underline;
  line-height: 18px;
  padding: 15px;
}
.inner-content-dashboard td {
  color: white;
  font-size: 13.89px;
  font-family: Roboto;
  font-weight: 500;
  line-height: 19.45px;
  padding: 15px;
}
.inner-content-dashboard table {
  width: 100%;
}
.meta-mask {
  background: linear-gradient(
    125deg,
    rgba(77, 76, 80, 0.3) 0%,
    rgba(42, 40, 44, 0.3) 100%
  );
  border-radius: 6.34px;
  padding: 15px;
}
.meta-mask h2 {
  color: white;
  font-size: 15px;
  margin: 0px;
  font-family: "Roboto";
  font-weight: 600;
  line-height: 20.51px;
  letter-spacing: 0.41px;
}
.react-loading-skeleton {
  --base-color: #5a576b !important;
  --highlight-color: #484258 !important;
  background-color: #413951 !important;
}
@media only screen and (max-width: 768px) {
  .main-content {
    margin-left: 0;
    width: 100%;
  }
  .sidebar {
    background: #000;
    z-index: 999;
  }
  .toggle-button {
    display: block;
  }
}
@media (max-width: 768px) {
  .content {
    margin-left: 0;
  }
}
.topline {
  height: 43px;
  width: 100%;
  background-color: #ed6464;
  color: #ffffff;
  font-weight: 700;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Cards Container */
.cards-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4 cards in a row */
  gap: 10px;
  max-width: 1400px;
  margin: 0 auto;
  margin-bottom: 15px;
}

/* Card Styling */
.data-card {
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s, box-shadow 0.3s;
  background: #ffffff1a;
  /* background: linear-gradient(312deg,rgba(184, 211, 255, 0) 0%, rgba(51, 90, 75, 0.91) 71%); */

  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  border: 1px solid #33594b;
}

.data-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.card-icon {
  font-size: 2.5rem;
  margin-bottom: 15px;
}

.data-card h3 {
  color: #fff;
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: 600;
}

.data-card h2 {
  color: #fff;
  font-size: 1.5rem;
  margin-bottom: 0px;
}

.data-card p {
  color: #fff;
  font-size: 0.9rem;
}

.claim-btn {
  background: linear-gradient(90deg, #379092 0%, #0aa7a1 60%, #1ba79d 100%);
  border: 1px solid rgba(201, 227, 235, 0.2);
  color: #fff;
  font-weight: 600;
  padding: 12px;
  border-radius: 9px;
}
.claim-btn:disabled {
  opacity: 40%;
}

/* Responsive Breakpoints */
@media (max-width: 1200px) {
  .cards-container {
    grid-template-columns: repeat(2, 1fr); /* 2 cards per row on tablets */
  }
}

@media (max-width: 768px) {
  .cards-container {
    grid-template-columns: 1fr; /* 1 card per row on mobile */
  }
}

/* tbody{
  height: 400px !important;
  overflow-y: scroll;
} */

.promo-modal .modal-content {
  border-radius: 12px;
  overflow: hidden;
  border: none;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
}
.promo-body h5 {
  color: #fff;
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 1rem;
}
.modal-content,
.wallet-modal .modal-content {
  /* background: none !important; */
  background-color: none !important;
  background: rgba(19, 206, 198, 0.14);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(1.9px);
  -webkit-backdrop-filter: blur(1.9px);
  border: 1px solid rgba(19, 206, 198, 0.3);
}
/* .promo-body,
.promo-header {
background: rgba(19, 206, 198, 0.44);
border-radius: 16px;
box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
backdrop-filter: blur(3.9px);
-webkit-backdrop-filter: blur(3.9px);
border: 1px solid rgba(19, 206, 198, 0.3);
} */

.promo-modal .close {
  color: white;
  text-shadow: none;
  opacity: 0.8;
}

.promo-modal .close:hover {
  opacity: 1;
  color: white;
}

.form-control:focus {
  border-color: #345b4c;
  box-shadow: 0 0 0 0.25rem rgba(21, 167, 158, 0.25);
}

.pdf-modal .modal-dialog {
  max-width: 800px !important;
}
.modal-dialog {
  max-width: 500px !important;
}

.dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  /* border: 1px solid #ccc; */
  border-radius: 5px;
  /* background-color: #fff; */
  z-index: 1000;
  padding: 10px;
  border: none;
  background: #282730;
  display: flex;
  justify-content: start;
  align-items: start;
  flex-direction: column;
  gap: 10px;
  border: 1px solid #ffffff3f;
  /* border-radius: 16px; */
  /* box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(1.9px);
  -webkit-backdrop-filter: blur(1.9px);
  border: 1px solid rgba(19, 206, 198, 0.3); */
}
.dropdown-item {
  color: #fff;
  text-align: start;
}
.dropdown-item:hover {
  color: #0aa7a1;
}

.token-graph {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    270deg,
    rgba(20, 58, 34, 1) 0%,
    rgba(23, 167, 159, 0) 17%
  );

  backdrop-filter: blur(4px);
}

.token-graph img {
  width: 70%;
  height: auto;
}


.tool-tip{
  background: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/dashboard.css"],"names":[],"mappings":"AACA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,QAAQ;EAKR,6BAA6B;;EAE7B,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,+EAA+E;EAC/E,+EAA+E;EAC/E,2CAA2C;EAC3C,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;EACE,+EAA+E;EAC/E,+EAA+E;EAC/E,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,yDAA0D;EAC1D,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yDAAkE;EAClE,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,+EAA+E;EAC/E,+EAA+E;EAC/E,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,+BAA+B;EAC/B;;;;GAIC;AACH;AACA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;;EAEpC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,+EAA+E;EAC/E,+EAA+E;EAC/E,mBAAmB;EACnB,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE;;;;GAIC;EACD,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,oCAAoC;AACtC;AACA;EACE;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,qCAAqC,EAAE,qBAAqB;EAC5D,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,2CAA2C;EAC3C,qBAAqB;EACrB,+FAA+F;;EAE/F,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yEAAyE;EACzE,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,qCAAqC,EAAE,+BAA+B;EACxE;AACF;;AAEA;EACE;IACE,0BAA0B,EAAE,6BAA6B;EAC3D;AACF;;AAEA;;;GAGG;;AAEH;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,iCAAiC;EACjC,iCAAiC;EACjC,oCAAoC;EACpC,mBAAmB;EACnB,yCAAyC;EACzC,4BAA4B;EAC5B,oCAAoC;EACpC,yCAAyC;AAC3C;AACA;;;;;;;;GAQG;;AAEH;EACE,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB;;;8CAG4C;AAC9C;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;;;;GAIC;;EAED,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;;AAGA;EACE,2BAA2B;AAC7B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");\n.main-content {\n  width: calc(100% - 250px);\n  padding: 20px;\n  margin-left: 250px;\n}\n.logo img {\n  width: 150px;\n}\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: -250px;\n  width: 250px;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.1);\n  transition: left 0.3s ease;\n  overflow-x: hidden;\n  padding: 20px;\n}\n\n.sidebar.open {\n  left: 0;\n}\n\n.toggle-button {\n  display: none;\n  position: absolute;\n  z-index: 99999;\n  top: 0px;\n  -moz-transform: translate(125%, 0);\n  -ms-transform: translate(125%, 0);\n  -o-transform: translate(125%, 0);\n  -webkit-transform: translate(125%, 0);\n  transform: translate(125%, 0);\n\n  padding: 14px 0px;\n  border-radius: 6px;\n  background: rgba(1, 188, 141, 1);\n  border: 1px solid rgba(201, 227, 235, 0.2);\n  font-family: \"Inter\", sans-serif;\n  font-size: 18px;\n  font-weight: 400;\n  text-align: center;\n  color: rgba(223, 224, 231, 1);\n  background: transparent;\n  border: none;\n}\n\n.sidebar-content {\n  color: white;\n}\n\n.sidebar-content ul {\n  list-style-type: none;\n  padding: 0;\n  margin-top: 20px;\n}\n\n.sidebar-content ul li a {\n  color: white;\n  text-decoration: none;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16.1px;\n  font-weight: 500;\n  line-height: 12.11px;\n  display: block;\n  padding: 14px 10px;\n  border-radius: 5px;\n  margin-bottom: 14px;\n  background: #ffffff1a;\n}\n.sidebar-content ul li.active a {\n  /* background: linear-gradient(90deg, #5A576B 0%, #484258 60%, #413951 100%); */\n  /* background: linear-gradient(90deg, #408171 0%, #3f878f 60%, #4cbdb6 100%); */\n  background-color: rgba(255, 255, 255, 0.05);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(217, 217, 217, 0.2);\n}\n.sidebar-content ul li a:hover {\n  /* background: linear-gradient(90deg, #5A576B 0%, #484258 60%, #413951 100%); */\n  /* background: linear-gradient(90deg, #408171 0%, #3f878f 60%, #4cbdb6 100%); */\n  background-color: #36c478;\n  cursor: pointer;\n}\n.sidebar-content ul li a img {\n  margin-right: 10px;\n}\n.dashboardapp {\n  background-color: #0a0c1b;\n  min-height: 100vh;\n  height: 100%;\n  background-image: url(../../../public/images/heroback.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: bottom;\n}\n\n.documentation {\n  background-image: url(../../../public/images/documentation-bg.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  padding: 20px;\n  color: white;\n  position: absolute;\n  bottom: 10px;\n  width: 220px;\n}\n.documentation h5 {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 12.85px;\n  font-weight: 700;\n  line-height: 17.99px;\n  text-align: left;\n}\n.documentation p {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 11.01px;\n  font-weight: 400;\n  line-height: 11.01px;\n  text-align: left;\n}\n.documentation a {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 9.18px;\n  text-align: center;\n  border-radius: 5px;\n  background: rgba(0, 9, 11, 1);\n  border: none;\n  width: 100%;\n  padding: 15px 10px;\n  color: white;\n  display: block;\n  text-decoration: none;\n}\nsection.dashboardhero {\n  background: none;\n  min-height: auto;\n  height: auto;\n}\nsection.dashboardhero .calculator .content {\n  border-radius: 9px;\n}\nsection.wallethero .calculator .content {\n  background: none;\n  padding: 0px;\n}\nsection.wallethero .calculateform .calculate-btn button {\n  background: #162859;\n  justify-content: center;\n}\nsection.wallethero .calculateform .calculate-btn button:hover {\n  border: none;\n}\nsection.wallethero .react-tel-input .form-control {\n  width: 100%;\n  padding-left: 60px;\n}\nsection.wallethero .react-tel-input .selected-flag {\n  width: 48px;\n}\nsection.wallethero .react-tel-input .country-list {\n  text-align: left;\n  text-align: -webkit-left;\n  text-align: -moz-left;\n}\nsection.wallethero .react-tel-input .flag-dropdown {\n  background-color: #242424;\n  border: 1px solid #000;\n}\n.wallet-modal .modal-header {\n  justify-content: end;\n}\n.wallet-modal .modal-header svg {\n  font-size: 28px;\n  color: #fff;\n}\n.wallet-modal .modal-header svg:hover {\n  cursor: pointer;\n}\n.inner-content-dashboard {\n  padding: 25.1px 14px 26px 14px;\n  border-radius: 9px;\n  background: rgba(255, 255, 255, 0.1);\n}\nheader {\n  background: #ffffff1a;\n  border-radius: 12px;\n  padding: 12px 20px;\n}\n.header-btn {\n  border: 1px solid #ffffff;\n  background: #ffffff1a;\n  gap: 10px;\n  border-radius: 6px;\n  padding: 6px 12px;\n  color: #fff;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 19.5px;\n  letter-spacing: 0.4px;\n  text-align: center;\n  vertical-align: middle;\n  text-transform: uppercase;\n}\n.header-btn:is(:hover, :active) {\n  border: 1px solid #36c478;\n  color: #36c478;\n}\n\n.header-btn .image {\n  width: 25px;\n}\n.header-btn img {\n  width: 100%;\n  height: auto;\n}\n.inner-content-dashboard h2 {\n  color: white;\n  font-size: 22px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 800;\n  line-height: 30.8px;\n  letter-spacing: 0.34px;\n}\n.inner-balance {\n  /* background: linear-gradient(90deg, #5A576B 0%, #484258 60%, #413951 100%); */\n  /* background: linear-gradient(90deg, #408171 0%, #3f878f 60%, #4cbdb6 100%); */\n  /* background-color: #36C478; */\n  border-radius: 10px;\n  padding: 15px;\n  border: 1px solid;\n  background: #ffffff1f;\n  backdrop-filter: blur(101.58px);\n  border-image-source: linear-gradient(\n    272.61deg,\n    rgba(226, 226, 226, 0.5) 23.59%,\n    rgba(116, 125, 152, 0) 85.98%\n  );\n}\n.inner-content-dashboard p {\n  color: white;\n  font-size: 16px;\n  font-family: \"Roboto\";\n  font-weight: 400;\n  line-height: 18px;\n}\n.inner-balance p {\n  color: #e9edf7;\n  font-size: 17px;\n  font-family: \"Roboto\", sans-serif;\n  font-weight: 400;\n  line-height: 20px;\n}\n.inner-balance h1 {\n  color: white;\n  font-size: 30px;\n  font-family: Roboto;\n  font-weight: 500;\n  line-height: 42px;\n  line-break: anywhere;\n}\n.inner-balance h1 button svg {\n  color: #fff;\n}\n.balance h3 {\n  color: white;\n  font-size: 14px;\n  font-family: Roboto;\n  font-weight: 700;\n  line-height: 19.6px;\n}\n.Referral-code .form {\n  padding: 6px 7px 6px 22px;\n  border-radius: 5px;\n  background: rgba(255, 255, 255, 0.1);\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.Referral-code .form h4 {\n  font-family: \"Roboto\", sans-serif;\n  font-size: 16.63px;\n  font-weight: 400;\n  line-height: 20.12px;\n  text-align: center;\n  color: rgba(223, 224, 231, 1);\n  margin: 0px;\n}\n.progress-bar {\n  background-color: #36c478;\n}\n.Referral-code .form button, \n.validate-btn {\n  padding: 12px 24px;\n  border-radius: 6px;\n  /* background: linear-gradient(90deg, #5A576B 0%, #484258 60%, #413951 100%); */\n  /* background: linear-gradient(90deg, #379092 0%, #0aa7a1 60%, #1ba79d 100%); */\n  background: #000000;\n  border: 1px solid rgba(201, 227, 235, 0.2);\n  font-family: \"Inter\", sans-serif;\n  font-size: 18px;\n  font-weight: 400;\n  text-align: center;\n  color: rgba(223, 224, 231, 1);\n}\n.inner-content-dashboard .table-responsive {\n  white-space: nowrap;\n}\n.inner-content-dashboard table th {\n  color: white;\n  font-size: 16px;\n  font-family: \"Roboto\";\n  font-weight: 700;\n  text-decoration: underline;\n  line-height: 18px;\n  padding: 15px;\n}\n.inner-content-dashboard td {\n  color: white;\n  font-size: 13.89px;\n  font-family: Roboto;\n  font-weight: 500;\n  line-height: 19.45px;\n  padding: 15px;\n}\n.inner-content-dashboard table {\n  width: 100%;\n}\n.meta-mask {\n  background: linear-gradient(\n    125deg,\n    rgba(77, 76, 80, 0.3) 0%,\n    rgba(42, 40, 44, 0.3) 100%\n  );\n  border-radius: 6.34px;\n  padding: 15px;\n}\n.meta-mask h2 {\n  color: white;\n  font-size: 15px;\n  margin: 0px;\n  font-family: \"Roboto\";\n  font-weight: 600;\n  line-height: 20.51px;\n  letter-spacing: 0.41px;\n}\n.react-loading-skeleton {\n  --base-color: #5a576b !important;\n  --highlight-color: #484258 !important;\n  background-color: #413951 !important;\n}\n@media only screen and (max-width: 768px) {\n  .main-content {\n    margin-left: 0;\n    width: 100%;\n  }\n  .sidebar {\n    background: #000;\n    z-index: 999;\n  }\n  .toggle-button {\n    display: block;\n  }\n}\n@media (max-width: 768px) {\n  .content {\n    margin-left: 0;\n  }\n}\n.topline {\n  height: 43px;\n  width: 100%;\n  background-color: #ed6464;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Cards Container */\n.cards-container {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr); /* 4 cards in a row */\n  gap: 10px;\n  max-width: 1400px;\n  margin: 0 auto;\n  margin-bottom: 15px;\n}\n\n/* Card Styling */\n.data-card {\n  border-radius: 10px;\n  padding: 15px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  transition: transform 0.3s, box-shadow 0.3s;\n  background: #ffffff1a;\n  /* background: linear-gradient(312deg,rgba(184, 211, 255, 0) 0%, rgba(51, 90, 75, 0.91) 71%); */\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: column;\n  border: 1px solid #33594b;\n}\n\n.data-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n.card-icon {\n  font-size: 2.5rem;\n  margin-bottom: 15px;\n}\n\n.data-card h3 {\n  color: #fff;\n  font-size: 14px;\n  margin-bottom: 10px;\n  font-weight: 600;\n}\n\n.data-card h2 {\n  color: #fff;\n  font-size: 1.5rem;\n  margin-bottom: 0px;\n}\n\n.data-card p {\n  color: #fff;\n  font-size: 0.9rem;\n}\n\n.claim-btn {\n  background: linear-gradient(90deg, #379092 0%, #0aa7a1 60%, #1ba79d 100%);\n  border: 1px solid rgba(201, 227, 235, 0.2);\n  color: #fff;\n  font-weight: 600;\n  padding: 12px;\n  border-radius: 9px;\n}\n.claim-btn:disabled {\n  opacity: 40%;\n}\n\n/* Responsive Breakpoints */\n@media (max-width: 1200px) {\n  .cards-container {\n    grid-template-columns: repeat(2, 1fr); /* 2 cards per row on tablets */\n  }\n}\n\n@media (max-width: 768px) {\n  .cards-container {\n    grid-template-columns: 1fr; /* 1 card per row on mobile */\n  }\n}\n\n/* tbody{\n  height: 400px !important;\n  overflow-y: scroll;\n} */\n\n.promo-modal .modal-content {\n  border-radius: 12px;\n  overflow: hidden;\n  border: none;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);\n}\n.promo-body h5 {\n  color: #fff;\n  font-size: 26px;\n  font-weight: 700;\n  margin-bottom: 1rem;\n}\n.modal-content,\n.wallet-modal .modal-content {\n  /* background: none !important; */\n  background-color: none !important;\n  background: rgba(19, 206, 198, 0.14);\n  border-radius: 16px;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(1.9px);\n  -webkit-backdrop-filter: blur(1.9px);\n  border: 1px solid rgba(19, 206, 198, 0.3);\n}\n/* .promo-body,\n.promo-header {\nbackground: rgba(19, 206, 198, 0.44);\nborder-radius: 16px;\nbox-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\nbackdrop-filter: blur(3.9px);\n-webkit-backdrop-filter: blur(3.9px);\nborder: 1px solid rgba(19, 206, 198, 0.3);\n} */\n\n.promo-modal .close {\n  color: white;\n  text-shadow: none;\n  opacity: 0.8;\n}\n\n.promo-modal .close:hover {\n  opacity: 1;\n  color: white;\n}\n\n.form-control:focus {\n  border-color: #345b4c;\n  box-shadow: 0 0 0 0.25rem rgba(21, 167, 158, 0.25);\n}\n\n.pdf-modal .modal-dialog {\n  max-width: 800px !important;\n}\n.modal-dialog {\n  max-width: 500px !important;\n}\n\n.dropdown-list {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  width: 100%;\n  /* border: 1px solid #ccc; */\n  border-radius: 5px;\n  /* background-color: #fff; */\n  z-index: 1000;\n  padding: 10px;\n  border: none;\n  background: #282730;\n  display: flex;\n  justify-content: start;\n  align-items: start;\n  flex-direction: column;\n  gap: 10px;\n  border: 1px solid #ffffff3f;\n  /* border-radius: 16px; */\n  /* box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(1.9px);\n  -webkit-backdrop-filter: blur(1.9px);\n  border: 1px solid rgba(19, 206, 198, 0.3); */\n}\n.dropdown-item {\n  color: #fff;\n  text-align: start;\n}\n.dropdown-item:hover {\n  color: #0aa7a1;\n}\n\n.token-graph {\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: linear-gradient(\n    270deg,\n    rgba(20, 58, 34, 1) 0%,\n    rgba(23, 167, 159, 0) 17%\n  );\n\n  backdrop-filter: blur(4px);\n}\n\n.token-graph img {\n  width: 70%;\n  height: auto;\n}\n\n\n.tool-tip{\n  background: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
